var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    directives: [{
      name: "editable",
      rawName: "v-editable",
      value: _vm.blok,
      expression: "blok"
    }],
    staticClass: "SectionBlock relative grid mx-auto max-w-[1920px]",
    class: [_vm.blok.classes],
    style: _vm.containerStyles,
    attrs: {
      "id": _vm.blok.id
    }
  }, [_vm._l(_vm.blok.body, function (bodyBlok, i) {
    var _vm$blok, _vm$blok$layout, _vm$blok$layout$split, _vm$blok2, _vm$blok2$layoutMobil, _vm$blok2$layoutMobil2, _vm$blok3, _vm$blok3$layout, _vm$blok3$layout$spli, _vm$blok4, _vm$blok$mobileOrder, _vm$blok$mobileOrder$;
    return _c('StoryblokComponent', {
      key: bodyBlok._uid,
      style: {
        gridColumn: _vm.$matchMedia('lg') ? (_vm$blok = _vm.blok) === null || _vm$blok === void 0 ? void 0 : (_vm$blok$layout = _vm$blok.layout) === null || _vm$blok$layout === void 0 ? void 0 : (_vm$blok$layout$split = _vm$blok$layout.split(',')) === null || _vm$blok$layout$split === void 0 ? void 0 : _vm$blok$layout$split[i] // desktop
        : ((_vm$blok2 = _vm.blok) === null || _vm$blok2 === void 0 ? void 0 : (_vm$blok2$layoutMobil = _vm$blok2.layoutMobile) === null || _vm$blok2$layoutMobil === void 0 ? void 0 : (_vm$blok2$layoutMobil2 = _vm$blok2$layoutMobil.split(',')) === null || _vm$blok2$layoutMobil2 === void 0 ? void 0 : _vm$blok2$layoutMobil2[i]) || ((_vm$blok3 = _vm.blok) === null || _vm$blok3 === void 0 ? void 0 : (_vm$blok3$layout = _vm$blok3.layout) === null || _vm$blok3$layout === void 0 ? void 0 : (_vm$blok3$layout$spli = _vm$blok3$layout.split(',')) === null || _vm$blok3$layout$spli === void 0 ? void 0 : _vm$blok3$layout$spli[i]),
        // mobile
        gridRow: _vm.$matchMedia('lg') && (_vm$blok4 = _vm.blok) !== null && _vm$blok4 !== void 0 && _vm$blok4.sameRow ? '1 / -1' : undefined,
        order: _vm.$matchMedia('lg') ? i : ((_vm$blok$mobileOrder = _vm.blok.mobileOrder) === null || _vm$blok$mobileOrder === void 0 ? void 0 : (_vm$blok$mobileOrder$ = _vm$blok$mobileOrder.split(',')) === null || _vm$blok$mobileOrder$ === void 0 ? void 0 : _vm$blok$mobileOrder$[i]) || i
      },
      attrs: {
        "blok": bodyBlok
      }
    });
  }), _vm._v(" "), _vm.blok.debug ? _c('div', {
    staticClass: "grid debug pointer-events-none",
    style: _vm.containerStyles
  }, [_c('div', {
    staticClass: "full",
    style: {
      gridColumn: 'full'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-2",
    style: {
      gridColumn: '2/3'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-3",
    style: {
      gridColumn: '3/4'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-4",
    style: {
      gridColumn: '4/5'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-5",
    style: {
      gridColumn: '5/6'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-6",
    style: {
      gridColumn: '6/7'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-7",
    style: {
      gridColumn: '7/8'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-8",
    style: {
      gridColumn: '8/9'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-9",
    style: {
      gridColumn: '9/10'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-10",
    style: {
      gridColumn: '10/11'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-11",
    style: {
      gridColumn: '11/12'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-12",
    style: {
      gridColumn: '12/13'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-13",
    style: {
      gridColumn: '13/14'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-14",
    style: {
      gridColumn: '14'
    }
  })]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }